export const enum ProviderFilterPlace {
	BAR = 'bar',
	SETTINGS = 'settings',
}
